import { transformCurrencyAmountDto } from 'data/transformers/currency-amount';

const transformFreePushUpRules = _ref => {
  let {
    item_count,
    free_push_up_count
  } = _ref;
  return {
    minimumItems: item_count,
    awarded: free_push_up_count
  };
};

export const transformFreePushUps = _ref2 => {
  let {
    free_push_up_batch,
    free_push_ups_count,
    free_push_ups_expire_in_days
  } = _ref2;
  return {
    available: free_push_ups_count,
    expiryTimeInDays: free_push_ups_expire_in_days,
    freePushUpRules: free_push_up_batch ? transformFreePushUpRules(free_push_up_batch) : undefined
  };
};

const transformPushUpOption = _ref3 => {
  let {
    days,
    price,
    payable,
    description,
    price_per_day,
    discounted_price,
    default: isDefault,
    best_value,
    international,
    countries
  } = _ref3;
  // This transformer is used for two endpoints:
  // - `/push_ups/availability`
  // - `/push_ups/options`
  // However, their responses are slightly different.
  // Since `availability` endpoint is planed to be
  // removed - this quickfix is solving the issues for
  // now.
  const priceToUse = price || payable;
  return {
    days,
    price: priceToUse ? transformCurrencyAmountDto(priceToUse) : undefined,
    isDefault,
    description,
    pricePerDay: transformCurrencyAmountDto(price_per_day),
    discountedPrice: discounted_price ? transformCurrencyAmountDto(discounted_price) : undefined,
    isBestValue: !!best_value,
    international,
    countries
  };
};

export const transformPushUpOptions = dtos => dtos.map(transformPushUpOption);
export const transformPushUpMotivation = dto => ({
  title: dto.title,
  description: dto.description,
  highlight: dto.highlight
});
export const transformPushUpBulkDiscount = dto => ({
  itemCount: dto.item_count,
  discountPercent: dto.discount_percent
});
export const transformPushUpsAvailability = dto => ({
  freePushUps: transformFreePushUps(dto),
  isPushUpLimitReached: dto.push_up_limit_reached,
  isPaymentsAccountPresent: dto.has_payments_account,
  pushUpOptions: dto.push_up_options ? transformPushUpOptions(dto.push_up_options) : [],
  bulkDiscount: dto.bulk_discount ? transformPushUpBulkDiscount(dto.bulk_discount) : undefined,
  pushUpMotivation: dto.motivation ? transformPushUpMotivation(dto.motivation) : undefined
});
export const transformPushUpsOptions = dto => ({
  freePushUps: transformFreePushUps(dto),
  isPushUpLimitReached: false,
  isPaymentsAccountPresent: true,
  pushUpOptions: dto.options ? transformPushUpOptions(dto.options) : [],
  pushUpMotivation: dto.motivation ? transformPushUpMotivation(dto.motivation) : undefined
});

const transformPushUpOrderItem = dto => ({
  id: dto.id,
  itemId: dto.item_id,
  total: transformCurrencyAmountDto(dto.total),
  payable: transformCurrencyAmountDto(dto.payable),
  discount: transformCurrencyAmountDto(dto.discount),
  discounted: transformCurrencyAmountDto(dto.discounted)
});

export const transformPushUpOrderItems = function transformPushUpOrderItems() {
  let dtos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return dtos.map(transformPushUpOrderItem);
};
export const transformPushUpOrder = dto => {
  var _dto$tax_coverage_ava, _dto$tax_covered;

  return {
    id: dto.id,
    status: dto.status,
    freeCount: dto.free_count,
    totalCount: dto.total_count,
    total: transformCurrencyAmountDto(dto.total),
    payIn: transformCurrencyAmountDto(dto.pay_in),
    payable: transformCurrencyAmountDto(dto.payable),
    discount: transformCurrencyAmountDto(dto.discount),
    discounted: transformCurrencyAmountDto(dto.discounted),
    freePushUpsValue: transformCurrencyAmountDto(dto.free_push_ups_value),
    discountPercentage: dto.discount_percentage,
    pushUpOrderItems: transformPushUpOrderItems(dto.push_up_order_items),
    salesTax: dto.sales_tax ? transformCurrencyAmountDto(dto.sales_tax) : null,
    isTaxCoverageAvailable: (_dto$tax_coverage_ava = dto.tax_coverage_available) !== null && _dto$tax_coverage_ava !== void 0 ? _dto$tax_coverage_ava : null,
    isTaxCovered: (_dto$tax_covered = dto.tax_covered) !== null && _dto$tax_covered !== void 0 ? _dto$tax_covered : null
  };
};